import { httpClient } from './httpClient';
import {
  CaptchaChallengeResponse,
  LoginRequest,
  ResetPasswordRequest,
  RegisterRequest,
  SendSmsCodeRequest,
  AuthResponse,
  UserResponse
} from '@packages/global';

/**
 * 认证 API 模块
 * 处理登录、注册、获取当前用户等操作
 */
export class AuthApi {
  /**
   * 用户登录
   */
  async login(data: LoginRequest): Promise<AuthResponse> {
    return httpClient.post<AuthResponse>('/auth/login', data);
  }

  /**
   * 获取图片验证码
   */
  async getCaptcha(): Promise<CaptchaChallengeResponse> {
    return httpClient.get<CaptchaChallengeResponse>('/auth/captcha');
  }

  /**
   * 发送短信验证码
   */
  async sendSmsCode(data: SendSmsCodeRequest): Promise<void> {
    return httpClient.post<void>('/auth/sms-code', data);
  }

  /**
   * 用户注册
   */
  async register(data: RegisterRequest): Promise<AuthResponse> {
    return httpClient.post<AuthResponse>('/auth/register', data);
  }

  /**
   * 找回密码
   */
  async resetPassword(data: ResetPasswordRequest): Promise<void> {
    return httpClient.post<void>('/auth/reset-password', data);
  }

  /**
   * 获取当前登录用户信息
   */
  async getCurrentUser(): Promise<UserResponse> {
    return httpClient.get<UserResponse>('/auth/me');
  }
}

// 导出单例实例
export const authApi = new AuthApi();
